module.exports = __webpack_public_path__ + "img/estadao.331d17ae.webp";